import Splide from '@splidejs/splide';

const SPLIDE_OPTIONS = {
  perPage: 1,
  pagination: false,
  arrows: false,
  trimSpace: false,
  focus: 'center',
  padding: '48px',
  gap: '16px',
  breakpoints: {
    500: {
      trimSpace: true,
    },
    768: {
      trimSpace: false,
      // fixedWidth: 430,
      gap: '2rem',
      padding: '2rem',
    },
    1024: {
      trimSpace: false,
      // fixedWidth: 530,
      gap: '2rem',
      padding: '4rem',
    },
  },
};

const hasSlider = {
  beforeDestroy() {
    this.destroySlider();
  },
  data: () => ({
    sliderIndex: 0,
  }),
  methods: {
    initSlider() {
      if (this.$splide) {
        this.$splide.destroy();
        this.$splide = null;
      }
      const $splide = document.querySelector('.splide');
      if ($splide) {
        const options = { ...SPLIDE_OPTIONS, start: this.sliderIndex };
        this.$splide = new Splide($splide, options).mount();
        const splideList = this.$splide.root.querySelector('.splide__list');
        const splideTrack = this.$splide.root.querySelector('.splide__track');
        splideList.classList.add('h-full');
        splideTrack.classList.add('h-full');
        this.$splide.on('moved', index => {
          this.sliderIndex = index;
        });
      } else {
        console.log('slide container is not there');
      }
    },
    destroySlider() {
      if (this.$splide) {
        this.$splide.destroy();
      }
      this.$splide = null;
    },
    resetSlider() {
      return new Promise(resolve => {
        this.$nextTick(() => {
          if (this.$splide) {
            this.$splide.refresh();
          } else {
            this.initSlider();
          }
          resolve();
        });
      });
    },
  },
};

export default hasSlider;
